package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.strings.aliyotParasha
import com.eladfinish.bible.contest.extensions.replaceRegex

class MarkAliyotUseCase {

    operator fun invoke(
        parashaContent: String,
        areConnected: Boolean,
    ): String {
        var content = parashaContent
        val newline = " "
        val aliyot = aliyotParasha
        val aliyotSheniAdMaftir: List<String> = aliyot.subList(aliyot.indexOf("שני"), aliyot.indexOf("מפטיר") + 1) //include maftir
        content = content
            .replaceFirst(
                regex = StringConstants.Regex.getAliyahRegex(str = "1").toRegex(),
                replacement = "$newline[כהן]  "
            )
            .replaceFirst(
                regex = StringConstants.Regex.getAliyahRegex(str = "ל").toRegex(),
                replacement = "$newline[לוי]  "
            )
            .replaceFirst(
                regex = StringConstants.Regex.getAliyahRegex(str = "ש").toRegex(),
                replacement = "$newline[ישראל]  "
            )
        val twoSpaces = "  "
        val endBetHei = "[סוף קריאה לשני וחמישי]$twoSpaces"
        content = if (content.contains(other = "{ע}")) {
            content
                .replaceFirst(
                    regex = StringConstants.Regex.getAliyahRegex(str = "ע").toRegex(),
                    replacement = newline + endBetHei
                )
        } else {
            content
                .replaceFirst(
                    regex = "(${StringConstants.Regex.getAliyahRegex(str = "2")})".toRegex(),
                    replacement = "$newline$endBetHei$1"
                )
        }
        if (areConnected) {
            content = content.replaceFirst(regex = StringConstants.Regex.getAliyahRegex(str = "8").toRegex(), replacement = "{88} ")
        }
        aliyotSheniAdMaftir.forEachIndexed { index, aliyahName ->
            val aliyahIndex = (index + 2) + (if (areConnected && aliyahName != "מפטיר") 20 else 0)

            content = content.replaceRegex(
                regex = StringConstants.Regex.getAliyahRegex(aliyahIndex.toString()),
                replacement = "$newline[${aliyahName}]  "
            )
        }
        return content
    }

}
